export default "__VITE_ASSET__BzAGuzEU__"